function ChangeCollapsibleText(expand_button) {
    expand_button.addEventListener('click', () => {
        const expanded = expand_button.getAttribute('aria-expanded');
        if (expanded === 'true') {
            expand_button.innerHTML = 'Show less';
        } else {
            expand_button.innerHTML = 'Read more';
        }
    });
}

export default function bioCollapsibleInit(els) {
    els.forEach(el => new ChangeCollapsibleText(el));
}
